import { IOnInit } from "angular";
import { Record } from "../../../../../../../../records/server/crud";

export class AmendmentDetailViewController implements IOnInit {
  static $inject = [];

  amendment!: Record;
  constructor() {}

  $onInit(): void {}
}
